module.exports = "/_next/static/images/largeBackground-734c2b17bc43c178071579ac21df8719.png";